// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-wrapper{color:#444;background:#fff}.editor{max-height:25em;min-height:25em;padding:0 1.5em 1.5em}\n", ""]);
// Exports
module.exports = exports;
